import { render } from "./DMSOrders.vue?vue&type=template&id=e7859020"
import script from "./DMSOrders.vue?vue&type=script&lang=js"
export * from "./DMSOrders.vue?vue&type=script&lang=js"

import "./DMSOrders.vue?vue&type=style&index=0&id=e7859020&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__